export default __webpack_public_path__ + "static/media/hero1.17f6c44f.svg";